import { Container } from "./styles";
import { BrowserRouter as Router } from "react-router-dom";
import { NavHashLink, HashLink } from "react-router-hash-link";
import { useState } from "react";
import { CV_FILE_NAME, CV_URL } from "../../constants";
import { useLanguage } from "../../i18n/LanguageContext";

export function Header() {
  const [isActive, setActive] = useState(false);
  const { lang, setLang, t } = useLanguage();

  function toggleTheme() {
    let html = document.getElementsByTagName("html")[0];
    html.classList.toggle("light");
  }

  function closeMenu() {
    setActive(false);
  }

  return (
    <Container className={isActive ? "header-fixed menu-open" : "header-fixed"}>
      <Router>
        <HashLink smooth to="#home" className="logo">
          <span>hdarioDev</span>
        </HashLink>

        <input
          onChange={toggleTheme}
          className="container_toggle"
          type="checkbox"
          id="switch"
          name="mode"
        />
        <label htmlFor="switch">{t.header.toggleTheme}</label>

        {/* The label names the language you switch TO */}
        <button
          type="button"
          className="lang-switch"
          onClick={() => setLang(lang === "en" ? "es" : "en")}
          aria-label={t.header.switchLanguageLabel}
        >
          {lang === "en" ? "ES" : "EN"}
        </button>

        <nav className={isActive ? "active" : ""}>
          <NavHashLink smooth to="#home" onClick={closeMenu}>
            {t.header.nav.home}
          </NavHashLink>
          <NavHashLink smooth to="#about" onClick={closeMenu}>
            {t.header.nav.about}
          </NavHashLink>
          <NavHashLink smooth to="#portfolio" onClick={closeMenu}>
            {t.header.nav.work}
          </NavHashLink>
          <NavHashLink smooth to="#case-ok-delivery" onClick={closeMenu}>
            {t.header.nav.caseStudy}
          </NavHashLink>
          <NavHashLink smooth to="#contact" onClick={closeMenu}>
            {t.header.nav.contact}
          </NavHashLink>
          <a href={CV_URL} download={CV_FILE_NAME} onClick={closeMenu}>
            {t.header.nav.cv}
          </a>
        </nav>

        <div
          aria-expanded={isActive ? "true" : "false"}
          aria-haspopup="true"
          aria-label={isActive ? t.header.closeMenu : t.header.openMenu}
          className={isActive ? "menu active" : "menu"}
          onClick={() => {
            setActive(!isActive);
          }}
        ></div>
      </Router>
    </Container>
  );
}
